import type { GcCultureSelectorData } from './types';
import type { Nullable } from '@web-platform/shared-universal-types-utils/src/utils';

let gcCultureSelectorData: Nullable<GcCultureSelectorData> = null;

export const setGcCultureSelectorData = (newGcCultureSelectorData: GcCultureSelectorData): void => {
  if (gcCultureSelectorData === null) {
    gcCultureSelectorData = newGcCultureSelectorData;
  }
};

export const getGcCultureSelectorData = (): GcCultureSelectorData => {
  if (gcCultureSelectorData === null) {
    throw new Error('GC Culture Selector Data is not set.');
  }

  return gcCultureSelectorData;
};
